import React from 'react'
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonCard, IonCardContent, IonCardHeader, IonCardTitle,  IonIcon,  IonCardSubtitle, IonButton } from '@ionic/react'
import { logoWhatsapp, callOutline, logoFacebook, logoInstagram, mailOutline, logoYoutube, locateOutline } from 'ionicons/icons'


import './JoinUs.css'
import { Link } from 'react-router-dom'

const JoinUs = () => {
    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>
                        Join Us
                    </IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                <IonCard style={{display:'block'}}>
                    <IonCardContent>
                        <IonCard style={{ display: 'block' }}>
                            <IonCardHeader>
                                <IonCardTitle style={{ textAlign: 'center' }}>
                                    Contact Us
                        </IonCardTitle>
                            </IonCardHeader>
                            <IonCardContent style={{ display: 'block',textAlign:'left'}}>
                                <a style={{ color: 'white', textDecoration: 'none' }} href="https://api.whatsapp.com/send?phone=919804221906">

                                    <IonButton mode="ios" shape="round" color="success" expand="full">

                                        <IonIcon mode="ios" icon={logoWhatsapp} /> &nbsp;&nbsp;
                                Chat On Whatsapp

                                </IonButton>
                                </a>
                                <a style={{ color: 'white', textDecoration: 'none' }} href="tel:+919804221906">

                                    <IonButton mode="ios" shape="round" color="secondary" expand="full">
                                        <IonIcon mode="ios" icon={callOutline} /> &nbsp;&nbsp;
                                Call

                                </IonButton>
                                </a>

                                <a style={{ color: 'white', textDecoration: 'none' }} href="https://www.facebook.com/victor.balmiki">


                                    <IonButton mode="ios" shape="round" color="tertiary" expand="full">
                                        <IonIcon mode="ios" icon={logoFacebook} /> &nbsp;&nbsp;
                                FaceBook
                                </IonButton>
                                </a>

                                <a style={{ color: 'black', textDecoration: 'none' }} href="https://www.instagram.com/victorsk8master_w.b">


                                {/* https://www.facebook.com/victor.balmiki */}
                                    <IonButton mode="ios" shape="round" color="light" expand="full">
                                        <IonIcon mode="ios" icon={logoInstagram} /> &nbsp;&nbsp;
                                Instagram
                                </IonButton>
                                </a>

                                <a style={{ color: 'white', textDecoration: 'none' }} href="https://www.youtube.com/channel/UCn7xXBJp7Z-hcknTVxNwvhw">
                                    <IonButton mode="ios" shape="round" color="danger" expand="full">
                                        <IonIcon mode="ios" icon={logoYoutube} /> &nbsp;&nbsp;
                                        Youtube
                                    </IonButton>
                                </a>




                                <a style={{ color: 'white', textDecoration: 'none' }} href="mailto:victorbalmiki@gmail.com">
                                    <IonButton mode="ios" shape="round" color="medium" expand="full">
                                        <IonIcon mode="ios" icon={mailOutline} /> &nbsp;&nbsp;
                                E-mail
                            </IonButton>
                                </a>

                                <a style={{ color: 'white', textDecoration: 'none' }} href="https://www.google.com/maps/dir//Bidhan+Sishu+Udyan,+Bidhan+Sishu+Sarani,+Ghose+Bagan,+Kolkata,+West+Bengal+700054/@22.5863593,88.3247426,12z/data=!3m1!4b1!4m8!4m7!1m0!1m5!1m1!1s0x3a0276731884aff1:0x74423f55fd62857a!2m2!1d88.394783!2d22.5863745">
                                    <IonButton mode="ios" shape="round" expand="full">
                                        <IonIcon icon={locateOutline} />&nbsp;&nbsp;
                                        Address
                                        </IonButton>
                                </a>



                            </IonCardContent>
                        </IonCard>
                        <IonCard>
                            <IonCardHeader style={{ display: 'block', textAlign: 'center' }}>
                                <IonTitle>
                                    Training Schedule
                                        </IonTitle>
                            </IonCardHeader>
                            <IonCardContent>
                                <table className="session">

                                    <tr className="session">
                                        <th className="session">Day</th>
                                        <th className="session">Morning Session</th>
                                        <th className="session">Evening Session</th>
                                        </tr>


                                    <tr className="session">
                                        <th className="session">Monday</th>
                                        <th className="session">Off</th>
                                        <th className="session">4pm - 6pm</th>
                                    </tr>
                                    <tr className="session">
                                        <th className="session">Tuesday</th>
                                        <th className="session">Off</th>
                                        <th className="session">4pm - 6pm</th>
                                    </tr>
                                    <tr className="session">
                                        <th className="session">Wednesday</th>
                                        <th className="session">Off</th>
                                        <th className="session">4pm - 6pm</th>
                                    </tr>
                                    <tr className="session">
                                        <th className="session">Thursday</th>
                                        <th className="session">Off</th>
                                        <th className="session">Off</th>
                                    </tr>
                                    <tr className="session">
                                        <th className="session">Friday</th>
                                        <th className="session">Off</th>
                                        <th className="session">4pm - 6pm</th>
                                    </tr>
                                    <tr className="session">
                                        <th className="session">Saturday</th>
                                        <th className="session">5am - 8am</th>
                                        <th className="session">4pm - 6pm</th>
                                    </tr>
                                    <tr className="session">
                                        <th className="session">Sunday</th>
                                        <th className="session">5am - 8am</th>
                                        <th className="session">Off</th>
                                    </tr>
                                </table>
                            </IonCardContent>
                        </IonCard>
                        <IonCard>
                            <IonCardHeader style={{textAlign:'center'}}>
                                <IonTitle>New-Comer Fees</IonTitle>
                            </IonCardHeader>
                            <IonCardContent>
                                <table className="session">
                                    <tr className="session">
                                        <th className="session">Frequency in a Week</th>
                                        <th className="session">Charge</th>
                                    </tr>
                                    <tr className="session">
                                        <th className="session">Once In A Week</th>
                                        <th className="session">400/-</th>
                                    </tr>
                                    <tr className="session">
                                        <th className="session">Twice In A Week</th>
                                        <th className="session">700/-</th>
                                    </tr>
                                    <tr className="session">
                                        <th className="session">Thrice In A Week</th>
                                        <th className="session">1000/-</th>
                                    </tr>
                                    <tr className="session">
                                        <th className="session">4 Days In A Week</th>
                                        <th className="session">1300/-</th>
                                    </tr>
                                    <tr className="session">
                                        <th className="session">5 Days In A Week</th>
                                        <th className="session">1600/-</th>
                                    </tr>
                                </table>
                            </IonCardContent>
                        </IonCard>
                        <IonCard>
                            <IonCardHeader style={{textAlign:'center'}}>
                                <IonTitle>
                                    Elite-Training Fees
                                </IonTitle>
                            </IonCardHeader>
                            <IonCardContent>
                                <table className="session">
                                    <tr className="session">
                                        <th className="session">Frequency in a Week</th>
                                        <th className="session">Charge</th>
                                    </tr>
                                    <tr className="session">
                                        <th className="session">Once In A Week</th>
                                        <th className="session">600/-</th>
                                    </tr>
                                    <tr className="session">
                                        <th className="session">Twice In A Week</th>
                                        <th className="session">1000/-</th>
                                    </tr>
                                    <tr className="session">
                                        <th className="session">Thrice In A Week</th>
                                        <th className="session">1250/-</th>
                                    </tr>
                                    <tr className="session">
                                        <th className="session">4 Days In A Week</th>
                                        <th className="session">1500/-</th>
                                    </tr>
                                    <tr className="session">
                                        <th className="session">5 Days In A Week</th>
                                        <th className="session">1750/-</th>
                                    </tr>
                                    <tr className="session">
                                        <th className="session">6 Days In A Week</th>
                                        <th className="session">2000/-</th>
                                    </tr>
                                </table>
                            </IonCardContent>
                            <IonCard>
                                <IonCardContent style={{ display: 'block', textAlign: 'center' }}>
                                    <IonCardSubtitle>Registration Fees 2000/- For All Skaters</IonCardSubtitle>
                                </IonCardContent>
                            </IonCard>
                        </IonCard>
                        <Link to="/joinus/enrollment" style={{ textDecoration: 'none' }}>
                            <IonButton mode="ios" color="danger" expand="full" shape="round">
                                Enroll Now !!!
                            </IonButton>
                        </Link>

                    </IonCardContent>
                </IonCard>
            </IonContent>
        </IonPage>
    )
}

export default JoinUs
